import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { useTheme, withTheme } from '@shared/lib';
export const FullListParticipants: FC = () => {
  const theme = useTheme();
  return <Wrapper>
      <WrapperInner>
        <div className="left">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 33" fill="none">
            <path d="M21.541 7.98286C19.04 5.45367 17.5343 4.2299 16.8657 3.82724C16.4163 3.58452 15.6735 3.50006 15.0333 3.50003L14.6105 3.5L14.5852 3.50001L14.287 3.5L14.2881 3.50221C13.7736 3.50929 13.282 3.53304 12.815 3.56939C10.905 3.71809 9.94995 3.79244 8.27883 5.44652C6.60772 7.10059 6.49757 8.2302 6.27727 10.4894C6.11641 12.1391 6 14.1441 6 16.5C6 18.4381 6.07824 20.1387 6.19556 21.5994C6.41325 24.3095 6.5221 25.6645 8.27174 27.4023C10.0214 29.1401 11.2861 29.2331 13.8157 29.419C14.5091 29.47 15.2401 29.5 16 29.5C16.7599 29.5 17.491 29.47 18.1844 29.419C20.7139 29.2331 21.9786 29.1401 23.7282 27.4023C25.4778 25.6646 25.5867 24.3096 25.8044 21.5996C25.9217 20.1389 26.0008 18.4382 26.0008 16.5C26.0008 15.423 26.0255 13.3431 25.6796 12.7281C25.6323 12.644 25.5444 12.5918 25.4391 12.4542C24.8754 11.7175 23.6483 10.1139 21.541 7.98286Z" fill="url(#paint0_linear_8503_21685)" />
            <path d="M17.4091 14.3184C16.907 14.3184 16.5 14.7254 16.5 15.2275C16.5 15.7295 16.907 16.1365 17.4091 16.1365H19.7759C20.2779 16.1365 20.685 15.7295 20.685 15.2275C20.685 14.7254 20.2779 14.3184 19.7759 14.3184H17.4091Z" fill={theme.colors.icon.white} />
            <path d="M11.3014 15.492C11.2734 15.6325 11.2734 15.8015 11.2734 16.1394V17.6818C11.2734 18.0197 11.2734 18.1887 11.3014 18.3292C11.4162 18.9062 11.8672 19.3573 12.4442 19.4721C12.5847 19.5 12.8261 19.5 13.1641 19.5C13.502 19.5 13.6887 19.5 13.8292 19.4721C14.4062 19.3573 14.8573 18.9062 14.9721 18.3292C15 18.1887 15 18.0197 15 17.6818V16.1394C15 15.8015 15 15.6325 14.9721 15.492C14.8573 14.915 14.4062 14.4639 13.8292 14.3491C13.6887 14.3212 13.502 14.3212 13.1641 14.3212C12.8261 14.3212 12.5847 14.3212 12.4442 14.3491C11.8672 14.4639 11.4162 14.915 11.3014 15.492Z" fill={theme.colors.icon.white} />
            <path d="M16.5 18.9718C16.5 18.4697 16.907 18.0627 17.4091 18.0627H20.5479C21.05 18.0627 21.457 18.4697 21.457 18.9718C21.457 19.4738 21.05 19.8809 20.5479 19.8809H17.4091C16.907 19.8809 16.5 19.4738 16.5 18.9718Z" fill={theme.colors.icon.white} />
            <path d="M12.9091 21.6818C12.407 21.6818 12 22.0888 12 22.5909C12 23.093 12.407 23.5 12.9091 23.5H19.8118C20.3139 23.5 20.7209 23.093 20.7209 22.5909C20.7209 22.0888 20.3139 21.6818 19.8118 21.6818H12.9091Z" fill={theme.colors.icon.white} />
            <path d="M25.6958 12.7459C24.3186 8.86828 20.2795 5.18899 16.8379 3.81055C18.5076 6.03544 17.7585 9.91576 18.7164 10.8844C19.8616 12.0425 23.7653 11.1622 25.6958 12.7459Z" fill="#FF8185" />
            <defs>
              <linearGradient id="paint0_linear_8503_21685" x1="1.36189" y1="6.02778" x2="31.1193" y2="11.9942" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FF7D7D" />
                <stop offset="1" stopColor="#E4001B" />
              </linearGradient>
            </defs>
          </svg>
          <Title>Полный список участников</Title>
        </div>
        <div className="right">
          <TextRight>PDF</TextRight>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 25" fill="none">
            <path d="M10.0021 4.66192C10.0021 4.0792 9.50549 3.61491 8.92679 3.68316C8.31313 3.75553 7.75022 3.84315 7.24958 3.9343C5.29166 4.29079 3.79078 5.79167 3.4343 7.74959C3.20608 9.00303 3 10.6468 3 12.5C3 14.3533 3.20608 15.997 3.4343 17.2504C3.79078 19.2083 5.29165 20.7092 7.24957 21.0657C8.50302 21.2939 10.1468 21.5 12 21.5C13.8532 21.5 15.497 21.2939 16.7504 21.0657C18.7083 20.7092 20.2092 19.2083 20.5657 17.2504C20.6567 16.7504 20.7443 16.1882 20.8166 15.5754C20.8849 14.9967 20.4206 14.5 19.8378 14.5C19.3179 14.5 18.884 14.8988 18.8215 15.4149C18.7564 15.9532 18.6788 16.4488 18.5981 16.8922C18.3907 18.0309 17.5309 18.8907 16.3922 19.0981C15.2298 19.3097 13.7083 19.5 12 19.5C10.2916 19.5 8.7702 19.3097 7.60782 19.0981C6.46909 18.8907 5.60928 18.0309 5.40195 16.8922C5.19032 15.7298 5 14.2084 5 12.5C5 10.7917 5.19032 9.27021 5.40195 8.10784C5.60928 6.9691 6.46909 6.10929 7.60783 5.90196C8.05176 5.82113 8.54806 5.74341 9.08715 5.67822C9.60332 5.61579 10.0021 5.18185 10.0021 4.66192Z" fill="#FAFAFA" />
            <path d="M20.9993 11.4991C21.0206 12.0516 20.5704 12.5 20.0169 12.5C19.4635 12.5 19.0164 12.0516 18.9934 11.4992C18.9317 10.0121 18.7453 8.55058 18.552 7.38023L11.7128 14.2155C11.3215 14.6064 10.687 14.6064 10.2956 14.2155C9.90428 13.8245 9.90428 13.1907 10.2956 12.7997L17.1485 5.95083C15.9713 5.75588 14.5044 5.56672 13.0019 5.50448C12.4489 5.48157 12 5.03492 12 4.48203C12 3.92915 12.4489 3.47944 13.0019 3.50073C14.7266 3.56712 16.3884 3.79006 17.6614 4.00669C18.76 4.19366 19.3093 4.28714 19.7607 4.73804C20.212 5.18894 20.3056 5.73769 20.4928 6.83519C20.7096 8.10682 20.9328 9.77623 20.9993 11.4991Z" fill="#FAFAFA" />
          </svg>
        </div>
      </WrapperInner>
    </Wrapper>;
};
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSCompact;
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xxs;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.regular;
const _exp4 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xxs;
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xs;
const _exp6 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xs;
const StyledTextRight = /*#__PURE__*/styled('div')({
  name: "StyledTextRight",
  class: "s1dwo932",
  propsAsIs: false,
  vars: {
    "s1dwo932-0": [_exp()],
    "s1dwo932-1": [_exp2(), "px"],
    "s1dwo932-2": [_exp3()],
    "s1dwo932-3": [_exp4(), "px"],
    "s1dwo932-4": [_exp5(), "px"],
    "s1dwo932-5": [_exp6(), "px"]
  }
});
const TextRight = withTheme(StyledTextRight);
const WrapperInner = /*#__PURE__*/styled('div')({
  name: "WrapperInner",
  class: "wbxi1mf",
  propsAsIs: false
});
const _exp1 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const _exp10 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.icon.primary;
const Wrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "we8zhdk",
  propsAsIs: false,
  vars: {
    "we8zhdk-0": [_exp1()],
    "we8zhdk-1": [_exp10()]
  }
}));
const _exp11 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const _exp12 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSText;
const _exp13 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xxs;
const _exp14 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.regular;
const _exp15 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.sm;
const _exp16 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xs;
const _exp17 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xs;
const Title = withTheme(/*#__PURE__*/styled('h2')({
  name: "Title",
  class: "t11196cb",
  propsAsIs: false,
  vars: {
    "t11196cb-0": [_exp11()],
    "t11196cb-1": [_exp12()],
    "t11196cb-2": [_exp13(), "px"],
    "t11196cb-3": [_exp14()],
    "t11196cb-4": [_exp15(), "px"],
    "t11196cb-5": [_exp16(), "px"],
    "t11196cb-6": [_exp17(), "px"]
  }
}));

require("./FullListParticipants.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./FullListParticipants.tsx");